import React from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  label: string;
}

// 패스픽 필터 UI 공용 개수 배지 — 필터 패널의 "적용 N"과 모바일 필터 버튼의 적용 개수가
// 같은 모양이어야 해서 한 곳에 모아 둔다.
function PathPickFilterCountBadge({ label }: Props) {
  return (
    <Flex
      height={"20px"}
      padding={"0 6px"}
      alignItems={"center"}
      justifyContent={"center"}
      borderRadius={"6px"}
      border={"0.5px solid #1272EF"}
      background={"#F0F9FF"}
      flexShrink={0}
    >
      <Text textStyle={"caption-bold"} color={"#1272EF"}>
        {label}
      </Text>
    </Flex>
  );
}

export default PathPickFilterCountBadge;
